// eslint-disable-next-line
import tw from "twin.macro";
import wave from "../../icons/Wave.svg";
import { ProfileData } from "../../data/ProfileData";
import React from "react";

import ProfileCard from "../Card/ProfileCard";
import Title from "../Title";
import { useStaticQuery, graphql } from "gatsby";
import Bounce from "react-reveal/Bounce";

const TeamSection = () => {
  const data = useStaticQuery(graphql`
    {
      aman: file(relativePath: { eq: "aman.png" }) {
        childImageSharp {
          gatsbyImageData(placeholder: BLURRED, formats: [AUTO, WEBP, AVIF])
        }
      }
      ayush: file(relativePath: { eq: "ayush.jpg" }) {
        childImageSharp {
          gatsbyImageData(placeholder: BLURRED, formats: [AUTO, WEBP, AVIF])
        }
      }
      baala: file(relativePath: { eq: "baala.jpg" }) {
        childImageSharp {
          gatsbyImageData(placeholder: BLURRED, formats: [AUTO, WEBP, AVIF])
        }
      }
    }
  `);

  return (
    <div
      tw="flex flex-col py-20 md:py-0 min-h-screen justify-center items-center  bg-no-repeat bg-cover  space-y-10 bg-gray-700 text-white p-5"
      style={{ backgroundImage: `url(${wave})` }}
    >
      <div tw="text-center space-y-10">
        <Title title="Our Teams" />
        <p tw="text-white">
          Teamwork divides the task and multiplies the success
        </p>
      </div>

      <div tw="grid md:grid-cols-3 gap-10 md:gap-10 max-w-7xl mx-auto">
        {ProfileData.map((card, index) => (
          <Bounce>
            <ProfileCard key={index} {...card} avatarImage={data[card.img]} />
          </Bounce>
        ))}
      </div>
    </div>
  );
};

export default TeamSection;
